import styles from './DashboardDetailsGrid.module.scss';

import React from 'react';
import { Container, Row, Col } from 'reactstrap';

import { ScrollOverPack, TweenOne, FadeUp, FadeIn } from 'src/components/Animations';
import ButtonLink from 'src/components/ButtonLink';

export default (props) => (
  <ScrollOverPack {...props}
                  className={props.className}
                  styleName='dashboard-details-grid'>
      <TweenOne key='0' component={Container} {...FadeIn}>
          <div className='h2'>Ops, finance, or customer service &mdash;</div>
          <div className='h2 text-blue'>There's a dashboard for everyone.</div>
      </TweenOne>
      <TweenOne key='1' component={Container} {...FadeUp}>
          <Row>
              <Col lg='4' md='6' xs='12' styleName='cell'>
                  <div styleName='heading'>Overview</div>
                  <div>
                      Late to your board meeting? Not to worry. Dazzle your
                      investors with exec-ready stats pulled from the overview
                      section.
                  </div>
              </Col>
              <Col lg='4' md='6' xs='12' styleName='cell'>
                  <div styleName='heading'>Service level summaries</div>
                  <div>
                      Not all services are created equal. See your company’s
                      unique breakdown of cost, volume and performance for each
                      carrier and service you ship with.
                  </div>
              </Col>
              <Col lg='4' md='6' xs='12' styleName='cell'>
                  <div styleName='heading'>Volume</div>
                  <div>
                      What’s trending? Monitor shipping volume by service type,
                      carrier, zone, or account number over time.
                  </div>
              </Col>
              <Col lg='4' md='6' xs='12' styleName='cell'>
                  <div styleName='heading'>Cost</div>
                  <div>
                      Don’t let costs sneak up on you. Get ahead of potential
                      problems with clean cross-sections of your total costs,
                      unit costs, and more.
                  </div>
              </Col>
              <Col lg='4' md='6' xs='12' styleName='cell'>
                  <div styleName='heading'>Zone and weight</div>
                  <div>
                      Crush it in the lanes that matter most. Learn how zone and
                      weight distributions are affecting you in a matter of clicks.
                  </div>
              </Col>
              <Col lg='4' md='6' xs='12' styleName='cell'>
                  <div styleName='heading'>Time-in-transit</div>
                  <div>
                      Your customer experience is only as good as your latest
                      shipment. Catch performance issues before you learn about
                      them from upset customers.
                  </div>
              </Col>
              <Col lg='4' md='6' xs='12' styleName='cell'>
                  <div styleName='heading'>Geography</div>
                  <div>
                      Trying to pick a location for your next DC? Wondering why
                      so many customers from Florida are writing in to complain?
                      Wondering how much Alaska is costing you? Put your shipping
                      data on the map.
                  </div>
              </Col>
              <Col lg='4' md='6' xs='12' styleName='cell'>
                  <div styleName='heading'>Audit performance</div>
                  <div>
                      Check out your windfall gains from Galleon’s audit. View
                      and verify your invoice credits, and see which carriers and
                      services are driving them.
                  </div>
              </Col>
              <Col lg='4' md='6' xs='12' styleName='cell'>
                  <div styleName='heading'>And much, much more</div>
                  <div>
                      <ButtonLink to='/contact'>Contact us for a demo</ButtonLink>
                  </div>
              </Col>
          </Row>
      </TweenOne>
  </ScrollOverPack>
);



// WEBPACK FOOTER //
// ./src/components/DashboardDetailsGrid.js